import { useConfig } from '@/contexts/config-context';
import { Dialog, DialogContent, DialogTitle, Typography, DialogActions, Button } from '@mui/material'
import React, { useState } from 'react'

export default function ModalTerms() {
    const [open, setOpen] = useState(false);

    return (
        <>
            <a href="#" onClick={() => {
                setOpen(true);
            }}>Termos de Utilização</a>
            <TermsContent open={open} onClose={() => {
                setOpen(false);
            }} />
        </>
    )
}

const TermsContent = ({
    open,
    onClose
}) => {

    const config = useConfig();
    
    return (
        <Dialog open={open} onClose={onClose}>
        <DialogTitle>Termos de Utilização</DialogTitle>
        <DialogContent>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
                Termos de Utilização
            </Typography>

            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                1. Declarações do Subscritor:
            </Typography>
            <Typography variant="body1" paragraph>
                Na qualidade de Subscritor deste Título de Capitalização, aprovado conforme processo SUSEP que consta no título:
            </Typography>
            <Typography variant="body1" component="div" sx={{ pl: 2 }}>
                <Typography variant="body1" paragraph>
                    (i) Tenho conhecimento de que a contratação deste Título de Capitalização implica na automática adesão a todos os termos das Condições Gerais e do regulamento do Título de Capitalização, e que esse documento encontra-se ao meu dispor no site da SUSEP.
                </Typography>
                <Typography variant="body1" paragraph>
                    (ii) O contemplado poderá autorizar, de forma gratuita, o direito de uso do seu nome, imagem e voz para divulgação da campanha.
                </Typography>
                <Typography variant="body1" paragraph>
                    (iii) Concordo com os Termos de Uso e a Política de Privacidade.
                </Typography>
            </Typography>

            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                2. Resgate do Título:
            </Typography>
            <Typography variant="body1" paragraph>
                Você está adquirindo um Título de Capitalização cujo direito de resgate será revertido para o {config?.capitalizadora_entity_name}, certificado nos termos da regulamentação vigente, caso não haja comunicação à sociedade de capitalização sobre a desistência da cessão até o dia anterior à realização do primeiro sorteio previsto no título de capitalização.
            </Typography>

            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                3. Aceitação dos Termos:
            </Typography>
            <Typography variant="body1" paragraph>
                Ao clicar em comprar, você concorda com os termos, política de uso, regulamento e condições gerais do {config?.name}.
            </Typography>
        </DialogContent>
        <DialogActions>
            <Button onClick={onClose} variant="contained" color="primary">
                Fechar
            </Button>
        </DialogActions>
    </Dialog>
    );
}